'use client';

import React from 'react';

import { usePageContext } from '@abg/web-core/context/page/client-provider';

import { AbgDivider } from '../AbgDivider/AbgDivider';

import { DIVIDER_PALETTE_MAP } from './themed-divider.constants';
import { ThemedDividerProps } from './types';

export const ThemedDivider = ({
  type = 'horizontal',
  thickness = 1,
  theme = 'light',
}: ThemedDividerProps) => {
  const { brand } = usePageContext();

  const color = DIVIDER_PALETTE_MAP[brand][theme || 'light'];

  return <AbgDivider type={type} thickness={thickness} color={color} />;
};
